import React, { useState, useEffect } from "react";
import QrReader from "modern-react-qr-reader";
import Grid from '@mui/material/Grid';
import { Button, Typography } from '@mui/material';
import axios from 'axios';
import swal from "sweetalert";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    InputAdornment,
} from '@mui/material';
import TableFooter from '@mui/material/TableFooter';
import TablePagination from '@mui/material/TablePagination';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { useParams } from "react-router-dom";
import { useLocation } from 'react-router-dom';
const ScanWorkshopQrCode = (props) => {
//     const { id } = useParams();
const id = props.match.params.id;
//     const location = useLocation();
//   const URL = window.location.href;
//   const eventid = URL.split("/").slice(-1)[0];
//   useEffect(() => {
//     console.log("ID:", id);       // This will log 37
//     console.log("Event ID:", eventid); // This will log 60
// }, [id, eventid]);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchText, setSearchText] = useState('');
    //const P_id = 7;
    const [result, setResult] = useState("");
    const [singleWorkshopData, setsingleWorkshopData] = useState('');
    const [particpantAttendiData, setParticpantAttendiData] = useState([]);
    const [permissions, setrPermissions] = useState([]);
    const [eventid, setEventId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [facingMode, setFacingMode] = useState("environment"); 

    const [abstractHomeSetup, setAbstractHomeSetup] = useState({
        color_code: "",
        color_code_two: "",
        color_code_three: "",
        call_emergency: "",
        send_email: "",
        event_place: "",
        facebook_link: "",
        Instagram_link: "",
        linkedin_link: "",
        twitter_link: "",
        abstractFooterImage: "",
        abstractBannerImage: "",
        abstractSponserLogos: "",
        error_list: [],
    });
    React.useEffect(() => {
        axios.get(`api/add-home-setup-index?id=${eventid}`).then(res => {
            if (res.status === 200) {
                const getHomePageData = res.data.HomePageSetup;
                setAbstractHomeSetup(getHomePageData);
            }
        })

    }, [eventid]);



    let backGroundButtonByEvent = "";
    let backGroundByEvent = "";
    
    if (eventid) {
        backGroundButtonByEvent = `${abstractHomeSetup.color_code_two}`; // Assign the value conditionally
        backGroundByEvent = `${abstractHomeSetup.color_code}`; // Assign the value conditionally
    }
    else {
        backGroundButtonByEvent = '#145348'; // Default background color
        backGroundByEvent = "#145348";
    }
    //backgroundColor: backGroundButtonByEvent,



    React.useEffect(() => {
        axios.get(`api/getpermissionByRole`).then(res => {

            if (res.status === 200) {
                const datad = res.data.data.permissions;
                setrPermissions(datad)
            } else {

            }
        })

    }, []);

    useEffect(() => {
        axios.get(`api/workshop-single/${id}`).then((res) => {
            if (res.status === 200) {
                const wrkshp = res.data.swp;
                setsingleWorkshopData(wrkshp);
                if (wrkshp.event_id !== null) {
                    setEventId(wrkshp.event_id);
                }
                setLoading(false);
            }
        });
    }, [id]);


   





    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const filteredRows = particpantAttendiData.filter((row) =>
        Object.values(row).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchText.toLowerCase())
        )

    );
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;


    const [searchTerm, setSearchTerm] = useState('');
    const [filteredPosts, setFilteredPosts] = useState([]);

    useEffect(() => {
        const filteredData = particpantAttendiData.filter((row) => {
            const id = row.participant_data.id && row.participant_data.id.toString().toLowerCase().includes(searchTerm.toLowerCase());
            const nameMatches = row.participant_data.particent_name && row.participant_data.particent_name.toLowerCase().includes(searchTerm.toLowerCase());
            return id || nameMatches;
        });
        setFilteredPosts(filteredData);
    }, [searchTerm, particpantAttendiData]);

    const totalRecords = particpantAttendiData.length;
    const filteredRecordsCount = filteredPosts.length;


    const handleScan = (data) => {
        if (data) {
            setResult(data);
        }
    };

    const handleError = (error) => {
        console.error(error);
    };

    useEffect(() => {

        if (eventid !== null) {
            if (result) {
                sendDataToAPI(result);
            }

        }
    }, [eventid, result]);

    const toggleCamera = () => {
        setFacingMode(prevMode => (prevMode === "user" ? "environment" : "user"));
    };

    const resetResult = () => {
        setResult('');
    };
   

    const sendDataToAPI = async (data) => {
        try {
            if (eventid !== null) {
                await axios.get('/sanctum/csrf-cookie');
                const sendPayload = {
                    id,
                    eventid,
                    data,
                };
                const response = await axios.post(`/api/store-workshop-qrcode-scan-data`, sendPayload);
                if (response.data.status === 200) {
                    swal('Success', response.data.message, 'success');
                    // After successful update, update the table data
                    axios.get(`api/workshop-attendi/${eventid}/${id}`).then(res => {
                        if (res.status == 200) {
                            const wksp = res.data.wksAtndi;
                            setParticpantAttendiData(wksp);
                        } else {
                            swal('Error', "Check API Something Wrong", 'error');
                        }
                    });
                }
                else if (response.data.status === 201) {
                    swal('Alert', response.data.message, 'warning');
                } else if (response.data.status === 404) {
                    swal('Error', response.data.message, 'error');
                }
            } else {
                console.log("eventID", eventid);
                console.log('eventId is null, sendDataToAPI function not executed.');
            }
        } catch (error) {
            console.error('Error sending data to API:', error);
        }
    };



    useEffect(() => {
        axios.get(`api/workshop-attendi/${eventid}/${id}`).then(res => {
            if (res.status == 200) {
                const wksp = res.data.wksAtndi;
                const participantData = res.data.participantData;
                const workshopData = res.data.workshopData;

                setParticpantAttendiData(wksp);

            } else {
                swal('Error', "Check API Something Wrong", 'error');
            }
        });
    }, [eventid]);


    // const [facingMode, setFacingMode] = useState("environment");
    // const toggleCamera = () => {
    //     setFacingMode(prevMode => (prevMode === "user" ? "environment" : "user"));
    // };


    const convertToCSV = (data) => {
        try {
            if (!data || data.length === 0) {
                console.error('Data array is empty or undefined');
                return '';
            }

            const fieldMappings = {
                'participant_id': 'Participant ID',
                'participant_title': 'Participant Title',
                'participant_name': 'Participant Name',
                'participant_saudi_council_no': 'Saudi Council No',
                'particent_phone_number': 'Mobile',
                'participant_email': 'Participant Email',
                'workshop_name': 'Workshop Name',
                'datetime': 'Date and Time'
            };

            const headers = Object.values(fieldMappings);

            const rows = data.map((row) => {
                return [
                    row.participant_data.id || '',
                    row.participant_data.name_title || '',
                    row.participant_data.particent_name || '',
                    row.participant_data.particent_saudi_council_no || '',
                    row.participant_data.particent_phone_number || '',
                    row.participant_data.particent_email || '',
                    row.workshop_data.workshop_name || '',
                    row.datetime || ''
                ];
            });

            const csvContent = [
                headers.join(','),
                ...rows.map(row => row.join(','))
            ].join('\n');

            return csvContent;
        } catch (error) {
            console.error('Error converting data to CSV:', error);
            return '';
        }
    };


    // Function to handle download process
    const handleDownloadPartiticapantAttendanceDataCSV = () => {
        // Convert data to CSV format
        const csvData = convertToCSV(particpantAttendiData);

        // Create a Blob object from CSV data
        const csvBlob = new Blob([csvData], { type: 'text/csv' });

        // Create a URL for the Blob object
        const csvUrl = window.URL.createObjectURL(csvBlob);

        // Create a download link
        const downloadLink = document.createElement('a');
        downloadLink.href = csvUrl;
        downloadLink.download = 'Workshop_participent_attendance_data.csv';

        // Trigger download
        downloadLink.click();

        // Cleanup
        window.URL.revokeObjectURL(csvUrl);
    };


   


    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div style={{ minHeight: '100vh', maxWidth: '100%', padding: '0 20px' }}>
            <header style={{ marginBottom: '20px', backgroundColor:backGroundByEvent, color: 'white', textAlign: 'center' }}>
                <Typography variant="h4" >Event: {singleWorkshopData.event_name}</Typography>
                <Typography component="h6" variant="h6" sx={{ m: 1 }}>Workshop Name: {singleWorkshopData.workshop_name} - WorkshopCode: {singleWorkshopData.workshop_code}</Typography>
                <Typography component="h6" variant="h6" >Workshop Attendance</Typography>
            </header>
            <Grid container spacing={2} alignItems="flex-start" justify="center">
                <Grid item xs={12} sm={6} align="center">
                    <QrReader
                     delay={300} 
                     onError={handleError}
                      onScan={handleScan} 
                      style={{ width: '100%', maxWidth: '350px' }}
                     facingMode={facingMode} />
                    {result && (
                        <div>
                            <Typography variant="h6" sx={{ m: 2 }}>Result:</Typography>
                            <Typography>ID: {result}</Typography>
                            <Button variant="contained" color="primary" onClick={resetResult}>
                                Clear Result
                            </Button>
                        </div>
                    )}


                    <Button
                        variant="contained"
                        color="primary"
                        onClick={toggleCamera}
                        sx={{
                            backgroundColor: backGroundButtonByEvent,
                            marginTop: { xs: 2, sm: 2, md: 3, lg: 4 },
                            width: { xs: '100%', sm: '100%', md: 'auto', lg: 'auto' },
                        }}
                    >
                        {facingMode === "user" ? "Switch to Back Camera" : "Switch to Front Camera"}
                    </Button>
                    

                </Grid>
                <Grid item xs={12} sm={6} align="center">

                    <Typography>Total Records: {totalRecords} | Filtered Records: {filteredRecordsCount}</Typography>
                    <Grid item xs={12} sm={8}>
                        <TextField fullWidth label="Filter By: Name" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                    </Grid>
                    <TableContainer component={Paper} sx={{ mt: 5 }}>
                        {
                            permissions['p_workshop-attendance-download'] === true ?
                                <Button
                                    onClick={handleDownloadPartiticapantAttendanceDataCSV}
                                    sx={{
                                        float: 'right',
                                        marginRight: '1%',
                                        marginTop: '2%',

                                        backgroundColor: backGroundButtonByEvent,

                                        ":hover": {
                                            color: "white"
                                        }
                                    }}

                                    color='success'
                                    size='small'
                                    variant='contained'
                                >
                                    <FileDownloadIcon />
                                    Download CSV
                                </Button>
                                : ""}
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">Participant Qr ID</TableCell>
                                    <TableCell align="left">Participant Name</TableCell>
                                    <TableCell align="left">Workshop Name</TableCell>
                                    <TableCell align="left">Date And Time</TableCell>

                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {filteredPosts && filteredPosts.slice(startIndex, endIndex).map((row, index) => (
                                    <TableRow key={index}>
                                        <>
                                            <TableCell>{row.participant_data.id}</TableCell>
                                            <TableCell>{row.participant_data.particent_name}</TableCell>
                                            <TableCell>{row.workshop_data.workshop_name}</TableCell>
                                            <TableCell>{row.datetime}</TableCell>
                                        </>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, 100, 500, 1000, 10000, 100000]}
                            component="div"
                            count={filteredRows.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                </Grid>
            </Grid>
            {/* 
            <footer style={{ position: 'fixed', bottom: '0', left: '0', width: '100%', backgroundColor: 'green', padding: '10px', color: 'white', textAlign: 'center' }}>
               
                <Typography variant="body1">Your footer content here</Typography>
            </footer> */}

        </div>



    );
}

export default ScanWorkshopQrCode;
